/**
 * Created by andrey on 31.05.17.
 */

const cleverappsEvents = {
    GENERAL: {
        LEVEL_UP: "level_up"
    },

    CONVERSIONS: {
        AD_REACH: "adreach",
        EVERY_5_AD: "every5ad",
        BUY: "buy",

        SESSION_5_MINUTES: "session5min",

        AD_IMPRESSION: "adimpression",
        AD_REWARDED: "adrewarded",

        LOCATION_START: "locationstart",
        LOCATION_REACH: "locationreach",

        ROOM_CHANGE: "roomchange",
        ROOM_REACH: "roomreach",

        SHOP_OPEN: "shopopen",
        SHOP_TIME: "shoptime",

        LEVEL_RESTART: "levelrestart"
    },

    EARN: {
        HARD: "ehard",
        SOFT: "esoft",
        FLYING: "flying",
        PROMO: "promo",
        COOKIE_JAR: "cookie",
        CHEST: "chest",
        BOARD_COIN: "board",
        CLAN: "clan",
        MAGNIFIER: "magnifier",
        FRIEND_REQUEST: "request",
        RETURN: "return",
        SLOTMACHINE: "slotmachine",
        LEVEL_COMPLETE: "level_complete",
        CUSTOMER_ORDER: "customer_order",
        LIVES: "lives",
        BONUS_LEVEL_REWARD: "bonus_level",
        SIMPLE_REWARD: "simple_reward",
        REWARDED_PROMO: "promo_tasks",

        LEVEL_BASE_REWARD: "base_reward",
        LEVEL_EXTRA_REWARD: "extra_reward",
        LEVEL_UP: "levelup",

        PURCHASE: "purchase",
        DAILY_MINIGAME: "daily_minigame",
        DAILY_MINIGAME_BALLOONS: "daily_minigame_balloons",
        MISSION: "mission",
        MINESWEEPER: "minesweeper",
        VIDEO: "video",
        STAR_CHEST: "star_chest",
        WEEKLY_TOURNAMENT: "weekly_tournament",
        FIELD: "field",
        LOCATION: "location",
        LIBRARY: "library",
        OTHER: "other",
        QUEST: "quest",
        STICKERS_BOOK: "stickers_book",
        STICKERS_BOOK2: "stickers_book2",
        CHAT_PRESENT: "chat_present",
        GENIE: "genie",
        SPAWN: "spawn",

        LEVELMASTERY: "levelmastery"
    },

    SPENT: {
        HARD: "shard",
        BOOSTER: "booster",
        BOOSTER_BEFORE: "before",
        BARREL: "barrel",
        RUIN: "ruin",
        THIRD_ELEMENT: "third_element",
        PIXEL_OFFER: "pixel_offer",
        PAY_ISLAND: "island",
        WORKER: "worker",
        SKIP_VIP: "skip_vip",
        MAGNET: "magnet",
        DYNAMITE: "dynamite",

        LIVES: "lives",
        SOFT: "ssoft",
        UNIT: "unit",
        PAID_UNIT: "paid_unit",
        REFRESH: "refresh",
        CLAN: "clan",

        BACKPACK: "backpack",

        CONTINUE: "continue",

        TACTICAL_EXTEND: "tactical_extend",
        HERO_UPGRADE: "upgrade",
        BOMB_MOVES: "bomb",
        SLOT_MACHINE: "slot",
        HOMEFIX_CHOICE: "choice",

        INGREDIENT: "ingredient",
        OFFER: "offer",
        FOG: "fog",
        FOGBUY: "fogb",
        REFILL_TANK: "tank",
        GENIE_ENERGY: "genie",
        MINESWEEPER: "miner",
        PACK: "pack_",
        ORDER: "order",
        ENERGY_LOTTERY: "lottery",
        BATTLE_PASS: "battlepass",
        LAST_CHANCE: "lastchance",
        SPEED_UP: "speedup",
        FRUIT: "fruit",
        RESET: "reset",
        UNLOCK: "unlock",
        CARAVAN: "caravan",
        CUSTOMER: "customer",
        RECIPE_INGREDIENT: "ingred",
        RECIPE_INGREDIENT_ALL: "ingredall",
        FACTORY: "factory",
        WAREHOUSE: "warehouse",

        TROOP_CARDS: "troop",
        PIGGY_BANK: "piggy",
        LUCKY_BONUS: "lucky_bonus",
        PRIZE_CALENDAR: "prize_calendar",
        OCTOPUS_HUNT: "octopus_hunt",
        SPAWNER: "customer"
    },

    ADS: {
        FINISH: "ad_finish",
        SESSION_FINISH_REWARDED: "ad_session_finish_rewarded",
        COST: "ad_cost",
        CACHE: "ad_cache",
        READY: "ad_ready",
        CONNECTED: "ad_connected",

        AD_BLOCK_WINDOW_DAU: "ad_block_window_dau",

        AD_BLOCK_REWARDED_SUCCESS: "ad_block_r_success",
        AD_BLOCK_REWARDED_FAIL: "ad_block_r_fail",

        AD_BLOCK_STICKY_SUCCESS: "ad_block_s_success",
        AD_BLOCK_STICKY_FAIL: "ad_block_s_fail",

        ERROR_REWARDED: "ad_error_r",
        ERROR_INTERSTITIAL: "ad_error_i",

        LOAD_ERROR_REWARDED: "ad_load_error_r",
        LOAD_ERROR_INTERSTITIAL: "ad_load_error_i",

        PLACEMENT_REWARDED: "ad_placement_rewarded",
        LIMIT_REACHED: "ad_limit_reached",
        // an interstitial placement skipped because its limit was already reached; itemId the placement
        LIMIT_SKIP: "ad_limit_skip",
        CLICK_LOAD: "ad_click_load"
    },

    LOCATION: {
        ACTIVE: "location_active",
        PLAYED: "location_played",

        // what happened on a day of a scheduled location, for the charts by that day: itemId is the day, 1 on the first one
        DAY_ACTIVE: "location_day_active",
        DAY_PLAYED: "location_day_played",
        DAY_COMPLETED: "location_day_completed",
        DAY_QUEST: "location_day_quest",
        DAY_ENERGY: "location_day_energy",
        DAY_PAYMENT: "location_day_payment",

        FIRST_TIME: "location_first_time",
        PLAYED_TIME: "location_played_time",

        STARTED: "location_started",
        FINISHED: "location_finished",

        COMPLETED: "location_completed",

        FINISHED_OLD: "location_finished_old",
        REPLACED_OLD: "location_replaced_old",

        UNKNOWN_OPENED: "location_unknown_opened",
        UNKNOWN_OPENED_DAU: "location_unknown_opened_dau"
    },

    PLACEMENTS: {
        SHOWN: "placement_shown"
    },

    // system windows and failures the player actually saw, for the CRM activity log; itemId is the screen, error is the cause
    SYSTEM: {
        RESTART_WINDOW: "restart_window",
        RESTART_WINDOW_RETRY: "restart_window_retry",
        VERSION_CHECK: "version_check",
        UPGRADE_WINDOW: "upgrade_window",
        UPGRADE_WINDOW_UPDATE: "upgrade_window_update",
        UPGRADE_WINDOW_DISMISS: "upgrade_window_dismiss",
        TWO_TABS_WINDOW: "two_tabs_window",
        SYNC_CONFLICT_WINDOW: "sync_conflict_window",
        SYNC_CORRUPTED_WINDOW: "sync_corrupted_window",
        JS_ERROR: "js_error"
    },

    WEBGL: {
        CONTEXT_LOST: "context_lost",
        CONTEXT_LOST_INACTIVE: "context_lost_inactive",

        CONTEXT_LOST_DAU: "context_lost_dau",
        CONTEXT_LOST_INACTIVE_DAU: "context_lost_inactive_dau",

        CONTEXT_LOST_MULTIPLE: "context_lost_2"
    },

    STATS: {
        APP_INITIALIZE: "app_initialize",
        LOADER_PROGRESS: "loader_progress_",
        LEVEL_START: "level_start",
        SHOP_OPEN: "shop_open",
        SHOP_CLOSE: "shop_close",
        BUY_VIRTUAL_ITEM: "buy_virtual_item",
        BUY_ITEM: "buy_item",
        PAYMENTS: "payments",
        SUBSCRIPTION_PAYMENTS: "subscription_payments",
        LTV: "ltv_",
        PAYMENTS_TERMINATED: "payments_terminated",
        MISSING_PRODUCTS: "missing_products",
        VIDEO_PRODUCT_BUY: "video_product_buy",
        RATE_WINDOW: "rate_window",
        RATE_SEND: "rate_send",
        SOCIAL_REVIEW: "social_review_",
        NATIVE_REVIEW: "native_review_",
        TUTORIAL_STEP: "tutorial_",
        // FraudDetector: fraud_hit on every hit of a strategy (itemId the code, value the hits), fraud_reset when its normal action
        // clears the count, fraud once the install is marked; the mark itself travels in the cheater base parameter
        FRAUD: "fraud",
        FRAUD_HIT: "fraud_hit",
        FRAUD_RESET: "fraud_reset",
        LEVEL_FINISH: "level_finish",
        LEVEL_LEFT_MOVES: "level_left_moves",
        LEVEL_PASSED_TIME: "level_passed_time",
        LEVEL_STARS: "level_stars",
        UNIQUE_FINISH: "unique_level_finish",
        UNIQUE_START: "unique_level_start",
        LEVEL_QUICK_LOSE: "level_quick_lose",
        USE_ENERGY: "use_energy",
        NO_ENERGY: "no_energy",
        LOW_HARD: "low_hard",
        PROMO: "promo_",
        PROMO_SHOW: "promo_show_",
        PROMO_ERROR: "promo_error_",
        CROSSPROMO_SHOW: "crosspromo_show",
        CROSSPROMO_CLICK_FEATURED: "crosspromo_click_featured",
        CROSSPROMO_CLICK_GENRE: "crosspromo_click_genre",
        CROSSPROMO_CANCEL: "crosspromo_cancel",
        CROSSPROMO_ERROR: "crosspromo_error",
        CROSSPROMO_CLOSE: "crosspromo_close",
        MINI_PROMO_SHOW: "mini_promo_show",
        MINI_PROMO_CLICK: "mini_promo_click",
        MINI_PROMO_MORE: "mini_promo_more",
        MINI_PROMO_CLOSE: "mini_promo_close",
        LOGIN: "login",
        LOGIN_OPEN: "login_open",
        LOGIN_SUCCESS: "login_success",

        TIMESTART_OLD: "timestart_old",
        TIMESTART_NEW: "timestart_new",

        // Metrics
        PAYER_DAU: "payer_dau",
        CHANGED_AVATAR_DAU: "changed_avatar_dau",
        CHANGED_NICKNAME_DAU: "changed_nickname_dau",
        LOGGEDIN_DAU: "loggedin_dau",
        NEW_USERS_DAU: "day_1_dau",
        REWARDED_AVAILABLE_DAU: "rewarded_available_dau",
        REWARDED_LOADED_DAU: "rewarded_loaded_dau",
        REWARDED_NOADS_DAU: "rewarded_noads_dau",
        NOADS_ERROR: "noads_error-",
        REWARDED_DAU: "rewarded_dau",
        REWARDED_ERROR_DAU: "rewarded_error_dau",
        VIP_REWARDED_WATCHED: "vip_rewarded_watched",
        VIP_REWARDED_DAU: "vip_rewarded_dau",

        GAME_LEVEL_CONVERSION_DAYS: "gamelevel_conversion_d",

        RETURNS: "returns_",
        RETARGET: "retarget_",
        ENTRY_PAYLOAD: "entry_payload",

        FPS_RATE: "fps_rate",

        RESOLUTION: "resolution_",
        WEBP: "webp_",
        OS: "os_",
        DEVICE: "device",
        // itemId is the relaxed hash, details holds the strict hash and the traits (see DeviceFingerprint)
        DEVICE_FINGERPRINT: "device_fingerprint",
        // logged only when the WebGL context could not be created and cocos fell back to Canvas;
        // absence of the event means WebGL, so no counterpart event is logged for it
        CANVAS_RENDERER: "canvas_renderer",
        PLATFORM: "platform_",
        ANDROID_VERSION: "androidv_",
        APP_TRACKING: "app_tracking_",
        APP_LOVIN_ADS: "app_lovin_ads",
        ADMOB_ADS: "admob_ads",
        YANDEX_APP_ADS: "yandex_app_ads",

        INSTANT: {
            BOT_WANT: "instabot_want",
            BOT_SHOW: "instabot_show",
            BOT: "instabot",

            REQUEST: "instant_request",
            PAYMENT: "instant_payment-",
            CATALOG: "instant_catalog-",
            SUBSCRIPTION_CATALOG: "instant_subs_cat-",
            CONSUME: "instant_consume-",
            RESTORE: "instant_restore-",
            LIST_PURCHASES: "instant_list-",

            SUBSCRIPTION: "instant_subscr-",
            SUBSCRIPTION_LIST: "instant_sublist-",

            PLATFORM: "instant_platform-",
            ENTRY_POINT: "instant_epoint-",

            ADS_ERROR_REWARDED: "instantr",
            ADS_ERROR_INTERSTITIAL: "instanti"
        },

        MSSTART: {
            ADS_LOAD: "msstart_load-",
            ADS_PLAY: "msstart_play-",
            ADS_ADBLOCK: "msstart_adblock"
        },

        PUSHES: {
            SEND: "push_send-",
            CLICK: "push_click-",
            PERMITTED_DAU: "push_permitted_dau"
            // PERMISSION_WANT: "prm_want",
            // PERMISSION_SHOW: "prm_show",
            // PERMISSION_GOT: "prm_got"
        },

        PRODUCT: {
            OPEN: "product_open",
            SUCCESS: "product_success",
            RESTORE: "product_restore",
            RESTORE_RECEIVED: "product_restore_received",
            CONSUME_START: "product_consume_start",
            CONSUME_SUCCESS: "product_consume_success",
            CONSUME_FAILURE: "product_consume_failure"
        },

        BANNER: {
            DAU: "banner_dau",
            LOADING: "banner_loading",
            SHOWN: "banner_shown",
            HIDDEN: "banner_hidden"
        },

        XSOLLA: {
            INIT_WIDGET_FAILED: "xsolla_init_widget_failed",
            OPEN_WIDGET: "xsolla_open_widget"
        },

        CONFIG: {
            FETCH_START: "config_f_",
            FETCH_SUCCESS: "config_fs_",
            FETCH_FAILURE: "config_ff_"
        },

        CRM: {
            POST: "crm_post",
            POST_FAILED: "crm_post_failed",
            REPLY: "crm_reply",
            REPLY_SENT: "crm_reply_sent",
            REPLY_VIEWED: "crm_reply_viewed",
            LATE_REPLY: "crm_late_reply",
            RESOLVED: "crm_resolved",
            UNANSWERED: "crm_unanswered"
        }
    },

    WECHAT: {
        PAY_RESULT: "pay_result"
    },

    DEBUG: {
        CLEARANCE: {
            LOCALSTORAGE_CLEARED: "localstorage_cleared",
            LOCALSTORAGE_ERROR_SET_ITEM: "localstorage_error_set_item",
            LOCALSTORAGE_SESSION_EXPIRED: "localstorage_session_expired",
            LOCALSTORAGE_UNSUPPORTED: "localstorage_unsupported",
            CORRUPTED_SERVER_BETTER: "corrupted_serverbetter"
        },

        LOCAL_STORAGE: {
            OK: "ls_ok",
            ERROR: "ls_error",
            CLEARED: "ls_cleared"
        },

        UNITS_IN_FOG: "dbg-units_in_fog-",
        UNITS_KICKED_OUT: "dbg-units_kicked_out-",
        UNITS_RESTORE_IMPORTANT: "dbg-units_restore_import-",

        BOTS_LOAD: "bots_load",
        BOTS_LOAD_SUCCESS: "bots_load_success",

        RUMBLE_INITIALIZE: "rumble_initialize",
        RUMBLE_INITIALIZE_SUCCESS: "rumble_initialize_success",

        KNOCKOUT_CONNECTION: "knockout_connection",
        KNOCKOUT_CONNECTION_SUCCESS: "knockout_connection_success",

        FRAME_ERROR: "frame_error",
        FRAME_LOOP_BROKEN: "frame_loop_broken",
        CONTEXT_LOST_BOOT: "context_lost_boot",
        UPGRADE_SUCCESS: "upgrade_success",
        ERROR_RELOAD: "error_reload",
        LOAD_FAILURE: "load_failure",
        LOAD_RETRY: "load_retry",
        LOAD_SOUNDS_SKIPPED: "load_sounds_skipped",
        GRAVITY_INIT_ERROR: "gravity_init_error",
        GRAVITY_RECONNECT: "gravity_reconnect",

        UNKNOWN_MISSION_DAU: "unknown_mission_dau",
        MISSION_AB_REMOVE: "mission_ab_remove",
        PENDING_REQUESTS_FREEZE: "pending_requests_freeze",
        SECOND_LOGIN: "second_login",

        RENDER_TYPE: "render_type_",

        MISSION_REPLACED: "mission_replaced-",
        MISSION_REPLACED_REMOVED: "mission_replaced_removed-",
        MISSION_REPLACED_UNAVAILABLE: "mission_replaced_unavailable-",
        MISSION_REPLACED_PAST: "mission_replaced_past-",

        AD_FROZEN: "ad_frozen-",

        UNKNOWN_IN_FOG: "unknown_in_fog",

        OLD_USER_LOAD: "old_user_load-",
        OLD_USER_SYNC: "old_user_sync-",
        IMPORT_PROGRESS: "import_progress-",

        VERSION_DOWNGRADE: "version_downgrade",

        CANVAS_REDIRECT: "canvas_redirect-"
    },

    MIGRATION: "migration",
    MIGRATION_BACK: "migration_back",
    MIGRATION_INCOMPATIBLE: "migration_incompat",
    SOFT_CONVERSION_WINDOW: "soft_conversion_window",

    NEW_LEVELS_WINDOW_OPEN: "new_levels_window_open",

    BOOSTER_UNLOCKED_WINDOW_OPEN: "booster_unlocked_window_open",

    CLIENT_DOWNGRADE: "client_downgrade",
    SERVER_DOWNGRADE: "server_downgrade",

    OFFER_DAU: "offer_dau",
    OFFER_OPEN: "offer_open",
    OFFER_STAGE: "offer_stage",
    OFFER_BUY: "offer_buy",
    OFFER_START: "offer_start",

    OPEN_FOG: "open_fog",
    OPEN_FOG_TIME: "open_fog_time",

    BONUS_WORLD_LEVEL: "bonus_world_level",
    BONUS_WORLD_DAU: "bonus_world_dau",
    BONUS_WORLD_LEVEL_DAU: "bonus_world_level_dau",
    BONUS_WORLD_REWARD: "BONUS_WORLD_REWARD",

    TREASURE_SEARCH_RECEIVE_SHOVELS: "tsearch_receive_shovels",

    PINBALL_REWARD: "pb_reward",
    PINBALL_REWARD_COST: "pb_reward_cost",
    PINBALL_RECEIVE_CHIPS: "pb_receive_chips",
    PINBALL_RECEIVE_TICKETS: "pb_receive_tickets",
    PINBALL_PLAYED_GAMES: "pb_played_games",

    // Features
    META_LOCATION: "meta_location",
    METHA_ITEM: "metha_item",
    META_LEVEL: "META_LEVEL",
    SIMPLE_METHA_LEVELUP: "simple_metha_background",

    MAKE_CHOICE: "make_choice",
    REDO_CHOICE: "redo_choice",
    WIN_KNOCKOUT: "win_knockout",
    LOSE_KNOCKOUT: "lose_knockout",

    MINIGAME_FINISH: "minigame_finish",
    MINIGAME_REWARD: "minigame_reward",
    MINESWEEPER_START: "minesweeper_start",
    MINESWEEPER_VICTORY: "minesweeper_victory",
    DAILY_BONUS: "daily_bonus",
    SHORTCUT_MISSION_REWARD: "shortcut_mission_reward",
    ENTRANCE_MISSION_REWARD: "entrance_mission_reward",

    TACTICAL_EXTEND_SHOW: "tactical_extend_show",

    MESSAGE_SENT_FRIEND: "message_friend",
    MESSAGE_SENT_INVITE: "message_invite",
    MESSAGE_SENT_PREFIX: "message_sent_",
    MESSAGE_RECEIVED_PREFIX: "message_receive_",
    MESSAGE_CANCEL_PREFIX: "message_cancel_",
    MESSAGE_ERROR: "message_error",

    SELECT_FRIEND_ICON_PRESSED: "select_friend_icon_pressed",
    SELECT_FRIEND_SUCCESS: "select_friend_success",
    SELECT_FRIEND_CANCEL: "select_friend_cancel",
    SELECT_FRIEND_FAILED: "select_friend_failed",

    FRIEND_REQUEST_SENT: "request_sent",
    FRIEND_REQUEST_NOTSENT_COOLDOWN: "request_notsent_cooldown",
    FRIEND_REQUEST_NOTSENT_UNCLIMED: "request_notsent_unclimed",

    FRIEND_REQUEST_AWAITING: "request_awaiting",

    FRIEND_REQUEST_RECEIVE: "request_receive",
    FRIEND_REQUEST_COLLECT: "request_collect",

    INVITE_ICON_SHARE: "invite_icon_share",

    QUEST_START: "quest_s_",
    QUEST_FINISH: "quest_f_",

    SUBSCRIPTION_WINDOW_OPEN: "subscription_window_open",
    SUBSCRIPTION_REWARD: "subscription_reward",
    SUBSCRIPTION_BOUGHT: "subscription_bought",
    SUBSCRIPTION_CANCELLED: "subscription_cancelled",

    CUP_REWARD: "cup_reward_",
    CUP_DAU: "cup_dau_",
    CUP_PLAYERS: "cup_players_",

    SHARE_PROPOSED: "share_proposed_",
    SHARE: "share_",

    LEADERS_WINDOW_OPEN: "leaders_window_open",
    NEW_LEAGUE: "new_league",

    MOVES_SHOW: "moves_show",
    MOVES_BOUGHT: "moves_bought",
    MOVES_USED_FORCE: "moves_used_force",

    BOOSTERS_EXECUTE: "boosters_execute",
    BOOSTERS_USE: "boosters_use",
    BOOSTERS_USE_TYPE: {
        USER: "user",
        ADS: "ads",
        HARD: "hard"
    },

    HINT_USED: "hint_used",

    PIGGY_BANK: "pig",

    PRIZECAL_STAGE: "prizecal_stage",
    PRIZECAL_COMPLETE: "prizecal_complete",

    SPACE_RACE_INC_PROGRESS: "space_race_inc_progress",

    PROMO_REWARD: "promo_reward_",
    PROMOCODE_REWARD: "promcode_",

    // match3
    STAR_CHEST_OPEN: "star_chest_open",
    PLAY_TIMES: "play_times",
    BOOSTER_CELL_ADDED: "booster_cell_added",
    BOOSTER_CELL_COLLECTED: "booster_cell_collected",
    BOOSTER_CELL_RECEIVED: "booster_cell_recevied",
    BOOSTER_COMBO_NO_PLACE: "booster_combo_no_place",
    BOOSTER_MULTICOLOR_NO_PLACE: "booster_multicolor_no_place",

    // tripeaks
    UNDO_USED_FORCE: "undo_force",

    // merge
    MERGE_START: "merge_start",
    ORDER_COMPLETE: "order_complete",
    CURRENT_RESOURCE: "current_resource_",
    COMPLETE_RESOURCES: "complete_resources",
    ALL_RESOURCE_LINES_COMPLETED: "all_resource_lines_completed",
    NO_SPACE: "no_space",
    CURRENT_HERO: "current_hero_",
    COMPLETE_HEROES: "complete_heroes",
    CURRENT_PET: "curr_pet_",
    CURRENT_PETRARE: "curr_petr_",
    CURRENT_PETLEGEND: "curr_petl_",
    COMPLETE_PET: "comp_pet",
    COMPLETE_PETRARE: "comp_petr",
    COMPLETE_PETLEGEND: "comp_petl",
    PET_RATE: "pet_rate_",
    CURRENT_EVENT: "curr_event_",
    COMPLETE_EVENT: "comp_event_",

    UNITS_SHOP_COINS: "units_shop_coins",
    UNITS_SHOP_ITEM: "units_shop_item",

    SOFT_CURRENCY_BUY: "soft_buy",
    SOFT_CURRENCY_COST: "soft_cost",
    UNITS_SOLD: "units_sold",

    SPEND_WANDS: "spend_wands",

    MONSTER_SPAWN: "monster_spawn",
    MONSTER_DIE: "monster_die",

    BANK_COINS: "bank_coins",

    BATTLE_REGULAR: "battle_regular",
    BATTLE_BONUS: "battle_bonus",

    THIRD_ELEMENT_COUNT: "third_element_count",

    UNIT_VALUE: "value_",

    CLANS_DAU: "clans_dau",

    TRADE_WINDOW_OPEN: "trade_windowopen",
    TRADE_EXCHANGE: "trade_exchange_",

    BONUS_LEVEL_FINISH: "bonus_level_finish",

    LEVEL_MASTERY_STAGE: "levelmastery_stage_",

    LANDMARKS: {
        OPEN: "landmark_open_",
        REPLACE: "landmark_replace"
    },

    NOADS_PRODUCT: {
        WINDOW_OPEN: "noads_window_open",
        WINDOW_PURCHASE: "noads_window_purchase"
    },

    PLATFORM: {
        CONNECT: "connect",
        DISCONNECT: "disconnect"
    },

    AB_EXPERIMENTS: "ab",

    PASS_ALL_LOCATIONS: "pass_all_locations",
    PASS_ALL_LEVELS: "pass_all_levels",
    PASS_ALL_HEROES: "pass_all_heroes",
    PASS_ALL_EXPEDITIONS: "pass_all_expeditions"
};

if (typeof module !== "undefined") {
    module.exports = cleverappsEvents;
}
